<template>
  <div class="contenedor-cpanel">
    <BaseNotification2
      v-if="store.status.msg != null"
      :type="store.status.type"
      :text="store.status.msg"
      :closable="store.status.closable"
      @close="borrarNotificacion()"
    />
    <div class="contenedor-titulo">
      <h1>Mesa De Examen Noviembre 2025</h1>
      <div class="barra"></div>
    </div>
    <section class="contenedor_socios_lista">
      <router-link :to="`/mesas-de-examenes`" class="boton_volver_login"><span>&#8592;</span> Atrás</router-link>
      <AnotadosMesaExamenLista
        :data="{
          servicio_id: 25 // Pasar el servicio_id
        }"
      ></AnotadosMesaExamenLista>
    </section>
  </div>
</template>

<script>
import store from '../store'
import BaseNotification2 from '../components/BaseNotification2'
import AnotadosMesaExamenLista from '../components/AnotadosMesaExamenLista.vue'
export default {
  name: 'MesaDeExamenNoviembre2025',
  components: {
    AnotadosMesaExamenLista,
    BaseNotification2
  },
  data: function () {
    return {
      store
    }
  },
  methods: {
    borrarNotificacion () {
      this.store.setStatus({
        msg: null,
        type: null,
        title: null
      })
    }
  },
  mounted: function () {
    setTimeout(() => {
      this.borrarNotificacion()
    }, 4000)
  }
}
</script>

<style>

</style>
